<template>
    <div id='ItemCreateForm' class='row'>
        <BoxSideMenu
            :navSteps='steps'
            :activeStep='activeStepIdx'
        />
        <div class='col-9 FormContent' :key='resetIdx'>
            <div class=' CardName row'>
                <h4>Create an Item</h4>
            </div>
            <div v-if="this.activeStepName === 'vendor'" class='row' >
                <div class='col-12'>
                    <div class='row'>
                        <div class='col-6 SelectBox' >
                            <Select
                                label='Select Receipt to pre-recieve against'
                                store='ItemInfo'
                                name='receipt'
                                :options='receiptOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.vendor[0].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                    </div>
                    <div class='SectionTitle row'>
                        <h5>{{this.steps[this.activeStepName].formHeader}}</h5>
                    </div>
                    <div class='row'>
                        <div class='col-6'>
                            <CurrencyInput
                                label='Cost'
                                store='ItemInfo'
                                name='cost'
                                :validationRules="['required']"
                                :hasErrors='showErrors == false ? false : !validationGroups.vendor[1].valid'
                                placeholder='Enter Cost'
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6'>
                            <DateInput
                                label="Date Purchased"
                                store='ItemInfo'
                                name='purchaseDate'
                                :validationRules="['required']"
                                :hasErrors='showErrors == false ? false : !validationGroups.vendor[2].valid'
                                placeholder='Enter Date Purchased'
                                @validate-field='updateStepValidation'
                                
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Vendor'
                                store='ItemInfo'
                                name='vendor'
                                :options='vendorOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.vendor[3].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Vendor Location'
                                store='ItemInfo'
                                name='vendorLocation'
                                :options='vendorLocationOptions'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6'>
                            <TextBox
                                label="Vendor Item ID"
                                store='ItemInfo'
                                name='vendorItemId'
                                placeholder='Enter Vendor Item ID'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Buy Team'
                                store='ItemInfo'
                                name='buyTeam'
                                :options='buyTeamOptions'
                                :validationRules="['required']"
                                :hasErrors='showErrors == false ? false : !validationGroups.vendor[4].valid'
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6 SelectBox MultiSelect'>
                            <SelectMulti
                                label='Buyers (Select Multiple)'
                                store='ItemInfo'
                                name='buyers'
                                :options='buyerOptions'
                                :validationRules="['required']"
                                :hasErrors='showErrors == false ? false : !validationGroups.vendor[5].valid'
                                :multi='true'
                                @validate-field='updateStepValidation'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-12'>
                            <TextBox
                                label="Comment"
                                store='ItemInfo'
                                name='comment'
                                placeholder='Enter comment'
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="this.activeStepName === 'product'" class='row'>
                <div class='col-12'>
                    <form @submit.prevent='findItem' id='ExistingItem'>
                        <div class='row justify-content-between' id='ExistingItemFields'>
                            <div class='col-4 SearchBox'>
                                <TextBox
                                    label=""
                                    store='BuyTracker/ItemCreate'
                                    name='productNameSearch'
                                    placeholder='Search by Product Name'
                                />
                                <DisplayIcon
                                    name=' '
                                    icon='SearchIcon'
                                />
                                
                            </div>
                            <div class='col-4 SkuBox'>
                                <TextBox
                                    label="Existing Product SKU"
                                    store='BuyTracker/ItemCreate'
                                    name='productSkuSearch'
                                    placeholder='Search by Product SKU'
                                />
                            </div>
                            <div class='col-4 IdBox'>
                                <TextBox
                                    label="Existing Product ID"
                                    store='BuyTracker/ItemCreate'
                                    name='productIdSearch'
                                    placeholder='Search by Product ID'
                                />
                            </div>
                        </div>
                        <div class='searcherrors row'>
                            <span class='col-12 SearchError' v-if='itemSearchError'>{{itemSearchError}}</span>
                        </div>
                        <div class='row justify-content-end' id='ExistingItemButtons'>
                            <div class='spacer col-8'>&nbsp;</div>
                            <Button
                             btnAction='submit'
                             btnClass='col-1 UseBt'
                             CTA='USE'
                             />
                            <Button
                             btnAction='submit'
                             btnClass='col-2 LoadBt'
                             CTA='LOAD/EDIT'
                             />
                            <Button 
                                btnClass='col-1 ResetBt'
                                CTA='RESET'
                                btnAction='reset' 
                                btnTarget='reset-fields'
                                @reset-fields='resetFields'
                            />
                        </div>
                    </form>
                    <div class='row'>
                        <div class='col-8 SelectBox'>
                            <Select
                                label='Item Presets'
                                store='ItemInfo'
                                name='itemPreset'
                                :options='itemPresets'
                            />
                        </div>
                    </div>
                    <div class='SectionTitle row'>
                        <h5>{{this.steps[this.activeStepName].formHeader}}</h5>
                    </div>
                    <div class='row'>
                        <div class='col-12'>
                            <TextBox
                                label="Product Name"
                                store='ItemInfo'
                                name='productName'
                                placeholder='Enter Product Name'
                                :hasErrors='showErrors == false ? false : !validationGroups.product[0].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Brand'
                                store='ItemInfo'
                                name='brand'
                                :options='brandOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.product[1].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Gender'
                                store='ItemInfo'
                                name='gender'
                                :options='genderOptions'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Material'
                                store='ItemInfo'
                                name='material'
                                :options='materialOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.product[2].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Style'
                                store='ItemInfo'
                                name='style'
                                :options='styleOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.product[3].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Category'
                                store='ItemInfo'
                                name='category'
                                :options='categoryOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.product[4].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6'>
                            <TextBox
                                label="Style Number"
                                store='ItemInfo'
                                name='styleNumber'
                                placeholder='Enter Style Number'
                                :validationRules="['number']"
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Subcategory'
                                store='ItemInfo'
                                name='subcategory'
                                :options='subcategoryOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.product[5].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Color Family'
                                store='ItemInfo'
                                name='colorFamily'
                                :options='colorFamilyOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.product[6].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Size'
                                store='ItemInfo'
                                name='size'
                                :options='sizeOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.product[7].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6'>
                            <CurrencyInput
                                label='MSRP'
                                store='ItemInfo'
                                name='msrp'
                                placeholder='Enter Cost'
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="this.activeStepName === 'item'" class='row'>
                <div class='col-12'>
                    <div class='SectionTitle row'>
                        <h5>{{this.steps[this.activeStepName].formHeader}}</h5>
                    </div>
                    <div class='row'>
                        <div class='col-12'>
                            <TextBox
                                label="Item Description"
                                store='ItemInfo'
                                name='itemDescription'
                                placeholder='Enter Item Description'
                                :hasErrors='showErrors == false ? false : !validationGroups.item[0].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Condition'
                                store='ItemInfo'
                                name='condition'
                                :options='conditionOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.item[1].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                            
                        </div>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Origin'
                                store='ItemInfo'
                                name='origin'
                                :options='originOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.item[2].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Color'
                                store='ItemInfo'
                                name='color'
                                :options='colorOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.item[3].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6'>
                            <TextBox
                                label="Item Style Number"
                                store='ItemInfo'
                                name='itemStyleNumber'
                                placeholder='Enter Item Style Number'
                                :validationRules="['number']"
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6'>
                            <TextBox
                                label="Serial"
                                store='ItemInfo'
                                name='serial'
                                placeholder='Enter Serial'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-12'>
                            <SelectMultiArrows
                                label1='Available Extras'
                                label2='Selected Extras'
                                store='BuyTracker/ItemCreate'
                                name1='availableExtras'
                                name2='extras'
                                :options1='availableExtras'
                                :options2='extras'
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="this.activeStepName === 'summary'" class='row'>
                <div class='col-12'>
                    <div class='row'>
                        <div class='col-12 SummaryName'>
                            <h3>{{itemName}}</h3>
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-4 SummarySku'>
                            <h4>{{itemSku}}</h4>
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-12'>
                            <TextBox
                                label="Additional Description"
                                store='ItemInfo'
                                name='additionalDescription'
                                placeholder='Enter Additional Description'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Category'
                                store='ItemInfo'
                                name='category'
                                :options='categoryOptions'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                                :disabled='true'
                            />
                        </div>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Subcategory'
                                store='ItemInfo'
                                name='subcategory'
                                :options='subcategoryOptions'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                                :disabled='true'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-12 AddImage'>
                            <ImageUpload
                                name='productImageSrc'
                                imageDesc='Image Not Provided'
                                store='ItemInfo'
                                label='Select Image'
                            />
                        </div>
                    </div>
                    <div class='row BoxAddSection'>
                        <div class='col-6 AddItemToBox'>
                            <Select
                                label='Add Item To Box'
                                store='BuyTracker/ItemCreate'
                                name='selectedBox'
                                :options='boxOptions'
                                :disabled='false'
                            />
                        </div>
                        <div class='col-2 AddToBox'>
                            <Button 
                                CTA='Add To Box'
                                type='primary'
                                btnClass='BtnAdd'
                                btnAction='AddToBox'
                                btnTarget='addto-box'
                                @addto-box='addtoBox'
                            />
                        </div>
                        <div class='or col-1'><span>OR</span></div>
                        <div class='col-3 CreateBox'>
                            <Button 
                                btnAction='link'
                                btnTarget='/buy-tracker/box-create'
                                CTA='Create New Box'
                                type='primary'
                                btnClass='BtnCreate'
                            />
                        </div>
                    </div>
                    <div class='row CompleteItemCreate'>
                        <div class='col-4 Spacer'>&nbsp;
                        </div>
                        <div class='col-4'>
                            <Button 
                                CTA='Save and Create Item'
                                btnClass='BtnSave'
                                :disabled='formErrors'
                                btnAction='SaveItem'
                                btnTarget='save-item'
                                @save-item='saveItem'
                            />
                        </div>
                        <div class='col-4 Spacer'>&nbsp;
                        </div>
                    </div>
                </div>
            </div>
            <div class='row PageFooter'>
                <div class='col-12 text-center'>
                    <DotNav
                        :steps='steps'
                        @update-nav="updateNav"
                    />
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import BoxSideMenu from '../Nav/BoxSideMenu';
    import DotNav from '../Nav/DotNav';
    import Select from '../../../core/form/Select.vue';
    import SelectMulti from '../../../core/form/SelectMulti.vue';
    import DateInput from '../../../core/form/DateInput.vue';
    import CurrencyInput from '../../../core/form/CurrencyInput.vue';
    import TextBox from '../../../core/form/TextBox.vue';
    import Button from '../../../core/form/Button.vue';
    import SelectMultiArrows from '../../../core/form/SelectMultiArrows.vue';
    import DisplayIcon from '../../../icons/DisplayIcon';
    import ImageUpload from '../../../core/form/ImageUpload.vue';

    export default{
            name: 'ItemCreateForm',
            components: {
                BoxSideMenu,
                Select,
                CurrencyInput,
                DateInput,
                DotNav,
                DisplayIcon,
                TextBox,
                SelectMultiArrows,
                SelectMulti,
                ImageUpload,
                Button
            },
            data() {
                return {
                    resetIdx: 0,
                    showErrors:false,
                    steps: {
                        vendor: {
                            order: 0,
                            title: 'Where did you buy it?',
                            subtitle: 'Vendor Information',
                            formHeader: 'Purchase Information',
                            errors: true,
                            completed: false,
                            active: true
                        },
                        product: {
                            order: 1,
                            title: 'What type of product?',
                            subtitle: 'Add product info',
                            formHeader: 'Product Information',
                            errors: false,
                            completed: false,
                            active: false
                        },
                        item: {
                            order: 2,
                            title: 'What type of item?',
                            subtitle: 'Add item info',
                            formHeader: 'Item Information',
                            completed: false,
                            active: false,
                            errors: false
                        },
                        summary: {
                            order: 3,
                            title: 'Summary',
                            subtitle: 'Review and Confirm',
                            completed: false,
                            active: false,
                            errors: false
                        }
                    },
                    
                    currentItemCreation:[],
                    receiptOptions: [],
                    subcategoryOptions: [],
                    buyTeamOptions: [],
                    buyerOptions: [],
                    vendorOptions: [],
                    vendorLocationOptions: [],
                    brandOptions: [],
                    genderOptions: [],
                    materialOptions: [],
                    styleOptions: [],
                    categoryOptions: [],
                    subcategoryOptions: [],
                    colorFamilyOptions: [],
                    conditionOptions: [],
                    sizeOptions: [],
                    originOptions: [],
                    colorOptions: [],
                    boxOptions: [],
                    itemPresets: [
                        {value: 'LUX', label: 'LUX'},
                        {value: 'RTW', label: 'RTW'},
                    ],
                    availableExtras: [],
                    extras: [],
                    itemValidationGroups: {
                        vendor: [
                            {name: 'receipt', valid: false},
                            {name: 'cost', valid: false},
                            {name: 'purchaseDate', valid: false},
                            {name: 'vendor', valid: false},
                            {name: 'buyTeam', valid: false},
                            {name: 'buyers', valid: false}
                        ],
                        product: [
                            {name: 'productName', valid: false},
                            {name: 'brand', valid: false},
                            {name: 'material', valid: false},
                            {name: 'style', valid: false},
                            {name: 'category', valid: false},
                            {name: 'subcategory', valid: false},
                            {name: 'colorFamily', valid: false},
                            {name: 'size', valid: false}
                        ],
                        item: [
                            {name: 'itemDescription', valid: false},
                            {name: 'condition', valid: false},
                            {name: 'origin', valid: false},
                            {name: 'color', valid: false}
                        ],
                        summary: []
                    },
                    currentForm: {'name' : 'New Item', 'route': '/buy-tracker/item-create'}
            }},
            computed: {
                activeStepName() {
                    var match = null;
                    for (const [key, value] of Object.entries(this.steps)) {
                        if(value.active == true) {
                            match = key;
                        }
                    }
                    return match;
                },
                activeStepIdx: {
                    get(){
                        var match = this.$store.getters['BuyTracker/ItemCreate/currentPage'] || 0;
                        for (const [key, value] of Object.entries(this.steps)) {
                            //console.log('checking - '+ key + ' : ' + value);
                            if(value.order < match){
                                value.completed = (Object.values(this.validationGroups[key]).findIndex(x => x.valid == false) == -1) ? true : false;
                                value.errors = !value.completed;
                            }
                            value.active = (value.order == match) ? true : false
                        }
                        return match;
                    },
                    set(value){
                        return this.$store.dispatch('BuyTracker/ItemCreate/set', {field: 'currentPage', value}) 
                    }
                },
                itemName() {
                    return this.$store.getters['ItemInfo/productName']
                },
                itemSku(){
                    return this.$store.getters['ItemInfo/productSku']
                },
                itemSearchError(){
                    return this.$store.getters['ItemInfo/itemFetchError']
                },
                validationGroups:{
                    get () { return this.$store.getters['BuyTracker/ItemCreate/validationGroups']},
                    set (value) { return this.$store.dispatch('BuyTracker/ItemCreate/set', {field: 'validationGroups', value}) },
                },
                formErrors(){
                    let foundErrors = false;
                    let checkGroups = Object.entries(this.steps);
                    for(const step in checkGroups){
                        foundErrors = ((checkGroups[step].findIndex(x => x.errors == true)) != -1) ? true : foundErrors;
                    }
                    return foundErrors;
                },
                createdCollection(){
                    return this.$store.getters['ProductCollection/createdCollection']
                }
            },
            created(){
                console.log('created');
                this.getReceiptOptions();
                this.getSubcategoryOptions();
                this.getBuyTeamOptions();
                this.getBuyerOptions();
                this.getVendorOptions();
                this.getVendorLocationOptions();
                this.getBrandOptions();
                this.getGenderOptions();
                this.getMaterialOptions();
                this.getStyleOptions();
                this.getCategoryOptions();
                this.getColorFamilyOptions();
                this.getConditionOptions();
                this.getSizeOptions();
                this.getOriginOptions();
                this.getColorOptions();
                this.getBoxOptions();
                this.getAvailableExtrasFromStore();
                this.getExtras();
                this.loadValidationGroups();
                
            },
            mounted(){
                console.log('mounted');
                this.getAvailableExtras();
                this.$store.dispatch('ProductCollection/addFormToStorage', {name: 'New Item', route: '/buy-tracker/item-create'})
            },
            methods: {
                getReceiptOptions(){
                    this.$api.get('/api/faker', {}).then(response => {
                        this.receiptOptions = [
                            {value: 1, label: 'receipt 1'},
                            {value: 2, label: 'receipt 2'},
                            {value: 3, label: 'receipt 3'},
                            {value: 4, label: 'receipt 4'},
                        ]
                    });
                },
                getSubcategoryOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.subcategoryOptions = [
                            {value: 1, label: 'subcat 1'},
                            {value: 2, label: 'subcat 2'},
                            {value: 3, label: 'subcat 3'},
                            {value: 4, label: 'subcat 4'},
                            {value: 'Handbag', label: 'Handbag'}
                        ]
                    });
                },
                getBuyTeamOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.buyTeamOptions = [
                            {value: 1, label: 'buyteam 1'},
                            {value: 2, label: 'buyteam 2'}
                        ]
                    });
                },
                getBuyerOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.buyerOptions = [
                            {value: 1, label: 'buyer 1', selected: false},
                            {value: 2, label: 'buyer 2', selected: false},
                            {value: 'Taka', label: 'Taka', selected: false}
                        ]
                    });
                },
                getVendorOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.vendorOptions = [
                            {value: 1, label: 'vendor 1'},
                            {value: 2, label: 'vendor 2'},
                            {value: 'APRE', label: 'APRE'}
                        ]
                    });
                },
                getVendorLocationOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.vendorLocationOptions = [
                            {value: 1, label: 'vendor location 1'},
                            {value: 2, label: 'vendor location 2'},
                            {value: 'Japan', label: 'Japan'}
                        ]
                    });
                },
                getBrandOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.brandOptions = [
                            {value: 1, label: 'brand 1'},
                            {value: 2, label: 'brand 2'},
                            {value: 'Prada', label: 'Prada'}
                        ]
                    });
                },
                getGenderOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.genderOptions = [
                            {value: 1, label: 'gender 1'},
                            {value: 2, label: 'gender 2'}
                        ]
                    });
                },
                getMaterialOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.materialOptions = [
                            {value: 1, label: 'material 1'},
                            {value: 2, label: 'material 2'},
                            {value: 'Saffiano Lux', label: 'Saffiano Lux'}
                        ]
                    });
                },
                getStyleOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.styleOptions = [
                            {value: 1, label: 'style 1'},
                            {value: 2, label: 'style 2'},
                            {value: 'Promenade', label: 'Promenade'}
                        ]
                    });
                },
                getCategoryOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.categoryOptions = [
                            {value: 1, label: 'category 1'},
                            {value: 2, label: 'category 2'},
                            {value: 'Bags', label: 'Bags'}
                        ]
                    });
                },
                getColorFamilyOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.colorFamilyOptions = [
                            {value: 1, label: 'colorFamily 1'},
                            {value: 2, label: 'colorFamily 2'},
                            {value: 'Pink', label: 'Pink'}
                        ]
                    });
                },
                getConditionOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.conditionOptions = [
                            {value: 1, label: 'condition 1'},
                            {value: 2, label: 'condition 2'},
                            {value: 'B', label: 'B'}
                        ]
                    });
                },
                getSizeOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.sizeOptions = [
                            {value: 1, label: 'size 1'},
                            {value: 2, label: 'size 2'},
                            {value: 'Small', label: 'Small'}
                        ]
                    });
                },
                getOriginOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.originOptions = [
                            {value: 1, label: 'origin 1'},
                            {value: 2, label: 'origin 2'},
                            {value: 'Italy', label: 'Italy'}
                        ]
                    });
                },
                getColorOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.colorOptions = [
                            {value: 1, label: 'color 1'},
                            {value: 2, label: 'color 2'}
                        ]
                    });
                },
                getBoxOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.boxOptions = [
                            {value: 1, label: 'box 1'},
                            {value: 2, label: 'box 2'},
                            {value: 1, label: 'box 3'},
                            {value: 2, label: 'box 4'}
                        ]
                    });
                },
                getAvailableExtras() {
                    this.$api.get('/api/faker', {}).then(response => {
                        if (this.availableExtras = {}){
                            console.log('setting store values:');
                            this.availableExtras = [
                                {value: 1, label: 'Extra 1'},
                                {value: 2, label: 'Extra 2'},
                                {value: 3, label: 'Extra 3'},
                                {value: 4, label: 'Extra 4'},
                                {value: 5, label: 'Extra 5'},
                                {value: 6, label: 'Extra 6'}
                            ]
                            this.$store.dispatch('BuyTracker/ItemCreate/set',{field: 'availableExtras', value: this.availableExtras});
                        }
                    });
                },
                getAvailableExtrasFromStore() {
                    this.$store.getters["BuyTracker/ItemCreate/availableExtras"]
                },
                getExtras() {
                    this.$store.getters["BuyTracker/ItemCreate/extras"]
                },
                loadValidationGroups(){
                    this.validationGroups = (this.validationGroups == null) ? this.itemValidationGroups : this.validationGroups;
                },
                updateNav({currentStepIdx, newStepIdx}){
                    let currStepRef = this.steps[Object.entries(this.steps).find(step => step[1].order == currentStepIdx)[0]];
                    let newStepRef = this.steps[Object.entries(this.steps).find(step => step[1].order == newStepIdx)[0]];
                    if(newStepRef.errors == true){
                        this.showErrors = true;
                    }
                    currStepRef.errors = 
                       (this.validationGroups[this.activeStepName].findIndex(x => x.valid == false) == -1) ? false : true;
                    currStepRef.active = false;
                    currStepRef.completed = (newStepIdx > currentStepIdx) ? true : false;
                    newStepRef.active = true;
                    this.activeStepIdx = newStepIdx;
                },
                updateStepValidation({field, status}){
                    this.validationGroups[this.activeStepName][this.validationGroups[this.activeStepName].findIndex(x => x.name == field)].valid = status;
                },
                findItem(e){
                    //QNB0PBHEPH006
                    console.log('finditem called');
                    console.log('finditem: '+ e.target.productSkuSearch.value);
                    if(e.target.productSkuSearch.value != ''){
                        this.$store.dispatch('BuyTracker/ItemCreate/fetchItem', {sku: e.target.productSkuSearch.value, store: 'BuyTracker/ItemCreate'});
                        this.resetIdx++;
                    }else{
                        this.$store.commit('ItemInfo/updateState', {field: 'itemFetchError', value: 'Nothing to search'});
                    }
                },
                resetFields(){
                    this.$store.commit('ItemInfo/updateState', {field: 'itemFetchError', value: ''});
                    let theseFields = ['receipt', 'cost', 'purchaseDate', 'vendor', 'vendorLocation', 'vendorItemId', 'buyTeam', 'buyers', 'comment', 'productName', 'productSku', 'brand', 'gender', 'material', 'style', 'category', 'styleNumber', 'subcategory', 'colorFamily', 'size', 'msrp', 'itemDescription', 'condition', 'origin', 'color', 'serial', 'extras', 'additionalDescription', 'itemPreset', 'itemStyleNumber', 'productImageSrc']
                    for(const field in theseFields){
                        this.$store.dispatch('ItemInfo/set', {field: theseFields[field], value: null});
                    }
                },
                saveItem(value){
                    console.log('Saving - '+ value); //TODO - Save Item
                },
                addtoBox(value){
                    console.log('Adding - '+ value); //TODO - Add To Box
                },
                onFocus(e){
                    e.target.value = '';
                }
            }
        }
</script>
